import { useState, useEffect } from "react";
import Select from "react-select";
import api from "../../../services/api";
import { langoptions } from "../../../utils/constants";
import ImageAutoCropper from "./ImageCropper";
import EditAdModal from "./EditAdModal";

const NewspaperViewer = () => {
  const [selectedPage, setSelectedPage] = useState(0);
  const [newspapers, setNewspapers] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState(null);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [editions, setEditions] = useState([]);
  const [selectedEdition, setSelectedEdition] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState({ label: "Telugu", value: 1 });
  const [selectedPageName, setSelectedPageName] = useState({ value: "main", label: "Main Edition" });
  const [newspaperData, setNewspaperData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
  const [pageNames, setPageNames] = useState([]);
  const [preFillData, setPreFillData] = useState({});
  const [openEditModal, setOpenEditModal] = useState(false);
  const [croppedCanvas, setCroppedCanvas] = useState(null);
  const [originalUrls, setOriginalUrls] = useState([]);

  const showStateDistrictFilters = selectedPageName?.value !== "main";

  useEffect(() => {
    const fetchNewspapers = async () => {
      const res = await api({ url: "/market/newspapers", method: "POST", data: {} });
      if (res?.code === 200) {
        const formatted = res.data
          .filter((item) => item?.name?.toLowerCase() !== "way2news")
          .map((item) => ({
            value: item.name.toLowerCase() === "dinathanthi" ? "dailythanthi" : item.id,
            label: item.name.toLowerCase() === "dinathanthi" ? "Dailythanthi" : item.name,
            logo: item.logo,
          }));
        setNewspapers(formatted);
        const eenadu = formatted.find((p) => p.label.toLowerCase() === "eenadu");
        if (eenadu) setSelectedNewspaper(eenadu);
      }
    };
    fetchNewspapers();
  }, []);

  useEffect(() => {
    if (selectedLanguage?.value) {
      api({ url: "/birdview/getPageNames", method: "POST", data: { lang_id: selectedLanguage.value } }).then((res) => {
        if (res?.code === 200) {
          const formatted = res.data.map((p) => ({ value: p.value ?? p.name, label: p.label ?? p.name }));
          setPageNames(formatted);
          setSelectedPageName(formatted.find((p) => p.value === "main") || formatted[0]);
        }
      });
    }
  }, [selectedLanguage]);

  useEffect(() => {
    if (selectedDate && selectedLanguage?.value && selectedPageName?.value && (!showStateDistrictFilters || (selectedState && selectedDistrict))) {
      const payload = {
        date: selectedDate,
        language: selectedLanguage.value,
        category: selectedPageName.value,
        state: showStateDistrictFilters ? selectedState.label : null,
        district: showStateDistrictFilters ? selectedDistrict.label : null,
        newspaper: selectedNewspaper?.value,
      };
      api({ url: "/birdview/epaper_editions", method: "POST", data: payload }).then((res) => {
        const data = Array.isArray(res?.data?.result) ? res.data.result : res.data || [];
        const formatted = data.map((e) => ({ value: e.value ?? e.label, label: e.label ?? e.value }));
        setEditions(formatted);
        setSelectedEdition(formatted.find((e) => e.value === "ts") || formatted[0]);
      });
    } else {
      setEditions([]);
      setSelectedEdition(null);
    }
  }, [selectedDate, selectedLanguage, selectedPageName, selectedState, selectedDistrict, selectedNewspaper]);

  useEffect(() => {
    if (showStateDistrictFilters && selectedDate && selectedLanguage?.value && selectedPageName?.value) fetchStates();
  }, [selectedDate, selectedLanguage, selectedPageName]);
  useEffect(() => {
    if (selectedState?.label && showStateDistrictFilters) fetchDistricts();
  }, [selectedState]);

  const fetchStates = async () => {
    const res = await api({ url: "/birdview/epaper_states", method: "POST", data: { date: selectedDate, language: selectedLanguage.value, category: selectedPageName.value, newspaper: selectedNewspaper.value } });
    const data = Array.isArray(res?.data?.result) ? res.data.result : res.data || [];
    setStates(data.map((s) => ({ value: s.value ?? s.label, label: s.label ?? s.value })));
  };

  const fetchDistricts = async () => {
    const res = await api({ url: "/birdview/epaper_districts", method: "POST", data: { date: selectedDate, language: selectedLanguage.value, category: selectedPageName.value, state: selectedState.label, newspaper: selectedNewspaper.value } });
    const data = Array.isArray(res?.data?.result) ? res.data.result : res.data || [];
    setDistricts(data.map((d) => ({ value: d.value ?? d.label, label: d.label ?? d.value })));
  };

  const handlePrevious = () => {
    setSelectedPage(Math.max(0, selectedPage - 1))
  }
  const handleNext = () => {
    setSelectedPage(Math.min(newspaperData.length - 1, selectedPage + 1))
  }
  useEffect(() => {
    if (selectedNewspaper?.value && selectedPageName?.value && selectedEdition?.value && selectedLanguage?.value) {
      const payload = {
        newspaper_id: selectedNewspaper.value,
        newspaper_name: selectedNewspaper.label,
        page_name: selectedPageName.value,
        edition: selectedEdition.value,
        state: showStateDistrictFilters ? selectedState?.label : null,
        district: showStateDistrictFilters ? selectedDistrict?.label : null,
        date: selectedDate,
        lang_id: selectedLanguage.value,
      };
      setLoading(true);
      api({ url: "/birdview/newspaper-data", method: "POST", data: payload })
        .then((res) => {
          if (res?.data) {
            setNewspaperData(res.data);
            setOriginalUrls(res.data.map((p) => p.link_url));
            setSelectedPage(0);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [selectedNewspaper, selectedPageName, selectedEdition, selectedState, selectedDistrict, selectedDate, selectedLanguage]);

  useEffect(() => {
    setPreFillData({
      date: selectedDate,
      page_no: newspaperData[selectedPage]?.page_num,
      newspaper: selectedNewspaper,
      language: selectedLanguage,
      pageName: selectedPageName,
      state: selectedState,
      district: selectedDistrict,
      edition: selectedEdition,
    });
  }, [newspaperData[selectedPage]?.page_num,selectedDate, selectedNewspaper, selectedLanguage, selectedPageName, selectedState, selectedDistrict, selectedEdition]);


  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 py-3">
          <div className="flex flex-col md:flex-row gap-4 items-center">
            {selectedNewspaper?.logo && <img src={selectedNewspaper.logo} alt={selectedNewspaper.label} className="h-12 object-contain" />}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-center flex-1">
              <input type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} className="w-48 px-3 py-2 border rounded-md focus:ring-2 focus:ring-blue-500" />
              <Select value={selectedNewspaper} onChange={setSelectedNewspaper} options={newspapers} placeholder="Newspaper" className="text-sm w-48" isDisabled={!newspapers.length} />
              <Select value={selectedLanguage} onChange={setSelectedLanguage} options={langoptions} placeholder="Language" className="text-sm w-48" />
              <Select value={selectedPageName} onChange={setSelectedPageName} options={pageNames} placeholder="Page Type" className="text-sm w-48" isDisabled={!pageNames.length} />
              {showStateDistrictFilters && (
                <>
                  <Select value={selectedState} onChange={setSelectedState} options={states} placeholder="State" className="text-sm w-48" />
                  <Select value={selectedDistrict} onChange={setSelectedDistrict} options={districts} placeholder="District" className="text-sm w-48" />
                </>
              )}
              <Select value={selectedEdition} onChange={setSelectedEdition} options={editions} placeholder="Edition" className="text-sm w-48" isDisabled={!editions.length} />
            </div>
          </div>
        </div>
      </div>

      {loading && <div className="text-center py-2 text-sm text-gray-600">Loading newspaper data...</div>}

      {newspaperData.length > 0 && (
        <div className="px-4 py-8">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="bg-gray-50 px-6 py-4 border-b flex justify-between">
              <h2 className="text-lg font-semibold">Page {newspaperData[selectedPage]?.page_num || "00"}</h2>
              <div className="flex items-center gap-4">
                <button onClick={handlePrevious} disabled={selectedPage === 0} className="p-2 disabled:opacity-50">
                  Previous
                </button>
                <span>
                  {selectedPage + 1} / {newspaperData.length}
                </span>
                <button onClick={handleNext} disabled={selectedPage === newspaperData.length - 1} className="p-2 disabled:opacity-50">
                  Next
                </button>
              </div>
            </div>
            <div className="p-6">
              <ImageAutoCropper handlePrevious={handlePrevious} handleNext={handleNext}  filterData={preFillData} imageUrl={newspaperData[selectedPage]?.link_url} setOpenEditModal={setOpenEditModal} setCroppedCanvas={setCroppedCanvas} />
            </div>
          </div>
        </div>
      )}

      {openEditModal && croppedCanvas && (
        <EditAdModal
          onClose={() => {
            setOpenEditModal(false);
            setCroppedCanvas(null);
          }}
          preFillData={preFillData}
          croppedCanvas={croppedCanvas}
          originalUrls={[originalUrls[selectedPage]]}
          imageUrl={newspaperData[selectedPage]?.link_url}
        />
      )}
    </div>
  );
};

export default NewspaperViewer;
